import { render, staticRenderFns } from "./OtherSupplierProfile.vue?vue&type=template&id=271339fe&"
import script from "./OtherSupplierProfile.vue?vue&type=script&lang=js&"
export * from "./OtherSupplierProfile.vue?vue&type=script&lang=js&"
import style0 from "./OtherSupplierProfile.vue?vue&type=style&index=0&id=271339fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports